// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BranchFilterController from "./branch_filter_controller"
application.register("branch-filter", BranchFilterController)

import BurialFormController from "./burial_form_controller"
application.register("burial-form", BurialFormController)

import BurialPersonLinkController from "./burial_person_link_controller"
application.register("burial-person-link", BurialPersonLinkController)


import CitationsController from "./citations_controller"
application.register("citations", CitationsController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import GoodAddressController from "./good_address_controller"
application.register("good-address", GoodAddressController)

import GraphExplorerController from "./graph_explorer_controller"
application.register("graph-explorer", GraphExplorerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HelpPopoverController from "./help_popover_controller"
application.register("help-popover", HelpPopoverController)

import ImageZoomController from "./image_zoom_controller"
application.register("image-zoom", ImageZoomController)

import InvolvementFormController from "./involvement_form_controller"
application.register("involvement-form", InvolvementFormController)

import InvolvementPickerController from "./involvement_picker_controller"
application.register("involvement-picker", InvolvementPickerController)

import InvolvementsController from "./involvements_controller"
application.register("involvements", InvolvementsController)

import LineageOwnerPickerController from "./lineage_owner_picker_controller"
application.register("lineage-owner-picker", LineageOwnerPickerController)

import LineageTreeController from "./lineage_tree_controller"
application.register("lineage-tree", LineageTreeController)

import LineageWizardController from "./lineage_wizard_controller"
application.register("lineage-wizard", LineageWizardController)

import LineagesFormController from "./lineages_form_controller"
application.register("lineages-form", LineagesFormController)

import PersonPickerController from "./person_picker_controller"
application.register("person-picker", PersonPickerController)

import PersonRelationshipPickerController from "./person_relationship_picker_controller"
application.register("person-relationship-picker", PersonRelationshipPickerController)

import PersonRelationshipsController from "./person_relationships_controller"
application.register("person-relationships", PersonRelationshipsController)

import SoldierFiltersController from "./soldier_filters_controller"
application.register("soldier-filters", SoldierFiltersController)

import SortableTableController from "./sortable_table_controller"
application.register("sortable-table", SortableTableController)

import SourcePickerController from "./source_picker_controller"
application.register("source-picker", SourcePickerController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TreeRenderController from "./tree_render_controller"
application.register("tree-render", TreeRenderController)

